
import {
    addToEndOfChain,
} from "@insite/client-framework/HandlerCreator";
import { chain ,RemoveAllFilters} from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";

// get the type of props using this
type HandlerParameter = Parameters<typeof RemoveAllFilters>[0];

function ClearMyVehicleFIlter(props: HandlerParameter) {
     props.dispatch?.({
        type: "MyVehicle/Filter/ClearSearch", 
        clearSearch:true 
    } as any) ; 
}
addToEndOfChain(chain, ClearMyVehicleFIlter);
